/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

const correspondenceHelpStyle = {
  list: {
    paddingInlineStart: "1rem",
  },
  headline: {
    display: "block",
    margin: "1rem 0",
  },
  accordionStack: {
    marginBottom: "1rem",
  },
  note: {
    marginTop: "1rem",
  },
};

export default correspondenceHelpStyle;
